import * as React from 'react';
import styled from 'styled-components';

import { InfoBox } from '@longline/aqua-ui/containers/InfoBox';
import { TertiaryButton } from '@longline/aqua-ui/controls/TertiaryButton';
import { NumberFormatter } from '@longline/aqua-ui/formatters/NumberFormatter';
import { CountryFormatter } from '@longline/aqua-ui/formatters/CountryFormatter';

import { IUser } from '../../../api/models/IUser';
import { useUsersContext } from '../IUsersContext';
import { RoleBox } from '../../../ui/RoleBox';
import { Role } from '../../../api/Permission';

interface IProps {
  value?: IUser;
  onClose: () => void;
}

const UserInfoBox = (props: IProps) => {
  const ctx = useUsersContext();

  // Optional because <ListView aux> injects the active item; render nothing
  // if no item is selected.
  if (!props.value) return null;
  const user = props.value;

  const handleView = () => {
    ctx.setUser(user);
    ctx.setUserReady('loading');
    ctx.setMode('view');
  }

  return (
    <InfoBox
      padded
      header={<HeaderText>{user.name}</HeaderText>}
      width={300}
      footer={<>
        <TertiaryButton onClick={handleView}>DETAILS</TertiaryButton>
      </>}
    >
      <InfoBox.Row name="Email" value={user.email}/>
      {user.country && <InfoBox.Row name="Country" value={<CountryFormatter type='both' value={user.country}/>}/>}
      <InfoBox.Row name="Systems" value={<NumberFormatter value={user.systems_count ?? 0} decimals={0}/>}/>
      <div style={{display: 'flex', justifyContent: 'end', gap: '8px', marginTop: '4px'}}>
        {(user.roles || []).sort().filter(r => r != Role.User).map((r, idx) => <RoleBox key={idx} full role={r}></RoleBox>)}
      </div>
    </InfoBox>
  )
}

const HeaderText = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export { UserInfoBox }
